import type { ReactNode } from "react";

import { cn } from "#/lib/utils";

export function PageEyeBrow({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <p className={cn("text-xs font-bold uppercase tracking-[0.14em] text-primary", className)}>
      {children}
    </p>
  );
}
